import React from "react";

export type TCrossIconProps = React.SVGAttributes<SVGElement>;



export function CrossIcon({ ...rest }: TCrossIconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path d="M0.645657 2.05972L2.05987 0.645508L15.3548 13.9404L13.9406 15.3546L0.645657 2.05972Z" fill="#00364E" />
      <path d="M15.3546 2.05972L13.9404 0.645508L0.645508 13.9404L2.05972 15.3546L15.3546 2.05972Z" fill="#00364E" />
    </svg>
  );
}
